<template>
  <div>
    <CCard>
    <CCardHeader>
      <slot name="header">
        Reporte de Colaboradores (Quincenal)
        <div class="card-header-actions" style="width: 1400px; margin-right: 18px;">
          <CRow>     
            <CCol v-if="customerSelect != 0 || ((role != 'administrator' && role != 'kam'))" md="2" style="text-align: right; width: 100px;"></CCol>
            <CCol v-if="customerSelect != 0 || role != 'administrator'" md="2" style="text-align: right; width: 100px;"></CCol>
            <CCol v-if="kamSelect != 0 || supportSelect != 0" md="2" style="text-align: right; width: 100px;"></CCol>

            <CCol md="2" style="text-align: right; width: 100px;"></CCol>
            <CCol md="2" style="text-align: right; width: 100px;">
              <CSelect class="m-0"
                :value.sync="periodSelect" 
                :options="periodOptions"
                @change="changeFilters"
              />  
            </CCol> 
            <CCol v-if="kamSelect == 0 && supportSelect == 0" md="2" style="text-align: right; padding-right: 0px;">
              <CSelect class="m-0" style="float: right; width: 100%;"
                :value.sync="customerSelect" 
                :options="customersOptions"
                @change="changeFilters"
              />   
            </CCol> 
            <CCol v-if="customerSelect == 0 && role == 'administrator'" md="2" style="text-align: right; padding-right: 0px;">
              <CSelect class="m-0" style="float: right; width: 100%;"
                :value.sync="kamSelect" 
                :options="kamsOptions"
                @change="changeFilters"
              />   
            </CCol> 
            <CCol v-if="customerSelect == 0 && (role == 'administrator' || role == 'kam')" md="2" style="text-align: right; width: 100px;">
              <CSelect class="m-0" style="float: right; width: 100%;"
                :value.sync="supportSelect" 
                :options="supportsOptions"
                @change="changeFilters"
              /> 
            </CCol>
            <CCol md="2" style="text-align: right; padding-right: 0px;">
              <CSelect class="m-0" style="float: right; width: 100%;"
                :value.sync="collaboratorSelect" 
                :options="collaboratorsOptions"
                @change="changeFilters"
              />   
            </CCol>       
          </CRow>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CRow>      
        <CCol md="12" style="text-align: center; font-size: 14px">
          <CDataTable 
            :hover="true"
            :striped="true"
            :border="true"
            :small="true"
            :fixed="true"
            :items="collaborators"
            :fields="fields"
            :items-per-page="20"
            :dark="false"
            pagination
          >
            <template #id="{item}"><td style="text-align: center;font-size: 11px" class="text-center">{{item.id}}</td></template>
            <template #name="{item}"><td style="text-align: center; font-size: 11px; width: 400px;">{{item.name}}</td></template>
            <template #day_1="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_1" 
                :checkout="item.end_time_day_1" 
                :total="item.total_day_1" 
                :done="item.done_day_1" 
                :percentage="item.done_percentage_day_1"
              />
            </template>
            <template #day_2="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_2" 
                :checkout="item.end_time_day_2"
                :total="item.total_day_2" 
                :done="item.done_day_2" 
                :percentage="item.done_percentage_day_2"
              />
            </template>
            <template #day_3="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_3" 
                :checkout="item.end_time_day_3"
                :total="item.total_day_3" 
                :done="item.done_day_3" 
                :percentage="item.done_percentage_day_3"
              />
            </template>
            <template #day_4="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_4" 
                :checkout="item.end_time_day_4"
                :total="item.total_day_4" 
                :done="item.done_day_4" 
                :percentage="item.done_percentage_day_4"
              />
            </template>
            <template #day_5="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_5" 
                :checkout="item.end_time_day_5"
                :total="item.total_day_5" 
                :done="item.done_day_5" 
                :percentage="item.done_percentage_day_5"
              />
            </template>
            <template #day_6="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_6" 
                :checkout="item.end_time_day_6"
                :total="item.total_day_6" 
                :done="item.done_day_6" 
                :percentage="item.done_percentage_day_6"
              />
            </template>
            <template #day_7="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_7" 
                :checkout="item.end_time_day_7"
                :total="item.total_day_7" 
                :done="item.done_day_7" 
                :percentage="item.done_percentage_day_7"
              />
            </template>
            <template #day_8="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_8" 
                :checkout="item.end_time_day_8"
                :total="item.total_day_8" 
                :done="item.done_day_8" 
                :percentage="item.done_percentage_day_8"
              />
            </template>
            <template #day_9="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_9" 
                :checkout="item.end_time_day_9"
                :total="item.total_day_9" 
                :done="item.done_day_9" 
                :percentage="item.done_percentage_day_9"
              />
            </template>
            <template #day_10="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_10" 
                :checkout="item.end_time_day_10"
                :total="item.total_day_10" 
                :done="item.done_day_10" 
                :percentage="item.done_percentage_day_10"
              />
            </template>
            <template #day_11="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_11" 
                :checkout="item.end_time_day_11"
                :total="item.total_day_11" 
                :done="item.done_day_11" 
                :percentage="item.done_percentage_day_11"
              />
            </template>
            <template #day_12="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_12" 
                :checkout="item.end_time_day_12"
                :total="item.total_day_12" 
                :done="item.done_day_12" 
                :percentage="item.done_percentage_day_12"
              />
            </template>
            <template #day_13="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_13" 
                :checkout="item.end_time_day_13"
                :total="item.total_day_13" 
                :done="item.done_day_13" 
                :percentage="item.done_percentage_day_13"
              />
            </template>
            <template #day_14="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_14" 
                :checkout="item.end_time_day_14"
                :total="item.total_day_14" 
                :done="item.done_day_14" 
                :percentage="item.done_percentage_day_14"
              />
            </template>
            <template #day_15="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_15" 
                :checkout="item.end_time_day_15"
                :total="item.total_day_15" 
                :done="item.done_day_15" 
                :percentage="item.done_percentage_day_15"
              />
            </template>
            <template #day_16="{item}">
              <DailyVisits 
                :checkin="item.start_time_day_16" 
                :checkout="item.end_time_day_16"
                :total="item.total_day_16" 
                :done="item.done_day_16" 
                :percentage="item.done_percentage_day_16"
              />
            </template>
            <template #total_visits="{item}">
              <td style="text-align: center; font-size: 28px;" :class="color(item.done_percentage)">
                <table border="1" style="width: 100%;">
                  <tr>
                    <td colspan="2" style="background-color: #fff;">{{ item.done_percentage }}%</td>
                  </tr>
                  <tr>
                    <td style="text-align: center; font-size: 16px; background-color: #ddd;" class="text-center">{{ item.total_visits }}</td>
                    <td style="text-align: center; font-size: 16px; background-color: #ddd;" class="text-center">{{ item.done_visits }}</td>
                  </tr>
                </table>
              </td>
            </template>
          </CDataTable>
        </CCol>        
      </CRow>
    </CCardBody>
  </CCard>
  </div>
</template>
<script>

import store from '../../../store'
import ws from '../../../services/rrhh';
import account_ws from '../../../services/account';

import DailyVisits from '../../../components/rrhh/DailyVisits.vue'

export default {
  name: 'Home',
  components: {
    DailyVisits
  },
  data () {
    return {
      code: 'general',
      collaborators: [],
      fields: [
          {key: 'id', label: 'No.'},
          {key: 'name', label: 'Colaborador'},
        ],
      
      collaboratorSelect: "0",
      collaboratorsOptions: [],
      kamSelect: "0",
      kamsOptions: [],
      supportSelect: "0",
      supportsOptions: [],
      customerSelect: "0",
      customersOptions: [],
      periodSelect: "20240501",
      periodOptions: [],
      lastPeriod: "20240501",
      lastKam: "0",
      lastSupport: "0",
      lastCustomer: "0",
      role: 'kam',
      collaborator_id: "0"
    }
  },
  mounted: async function() {
    this.loading();

    this.code = await this.$route.params.code;

    let is_administrator = localStorage.getItem("is_administrator");
    let is_kam = localStorage.getItem("is_kam");
    let is_support = localStorage.getItem("is_support");

    if(is_administrator == "false" && is_kam == "false"){
      window.location.href = "/#/welcome"; this.loaded(); return;
    }

    if(is_administrator != "false"){
      this.role = "administrator";
    }
    else{
      if(is_support != "false"){
        this.role = "support";
      }
      else{
        this.role = "kam";
      } 
    }

    let response = await ws.getPeriods(); 
    if(response.type == "success"){
      this.periodOptions = await this.$parseSelectOptions(response.data, "id", "name");
      if(response.data.length > 0){
        this.periodSelect = this.periodOptions[0].value;
      }      
    }

    let response5 = await ws.getCustomers(this.periodSelect); 
    if(response5.type == "success"){
      this.customersOptions = await this.$parseSelectOptions(response5.data, "id", "name",[{"label": "Todos los Clientes","value":""}]);
      if(response5.data.length > 0){
        this.customerSelect = this.customersOptions[0].value;
        this.lastCustomer = this.customerSelect
      }      
    }

    let response3 = await ws.getKams(this.periodSelect); 
    if(response3.type == "success"){
      this.kamsOptions = await this.$parseSelectOptions(response3.data, "id", "name",[{"label": "Todos los Kams","value":""}]);
      if(response3.data.length > 0 && this.lastKam == "0"){
        this.kamSelect = this.kamsOptions[0].value;
        this.lastKam = this.kamSelect
      }      
    }

    let response4 = await ws.getSupports(this.periodSelect); 
    if(response4.type == "success"){
      this.supportsOptions = await this.$parseSelectOptions(response4.data, "id", "name",[{"label": "Todos los Soportes","value":""}]);
      if(response4.data.length > 0 && this.lastSupport == "0"){
        this.supportSelect = this.supportsOptions[0].value;
        this.lastSupport = this.supportSelect
      }      
    }

    if(this.role != "administrator"){
      let response1 = await account_ws.getInfo(); 
    
      if(response1.type == "success"){
        if(response1.data.collaborator != null){
          this.collaborator_id = response1.data.collaborator.id+"";

          if(this.role == "support"){
            this.supportSelect = response1.data.collaborator.id+"";
            this.kamSelect = response1.data.collaborator.kam_id+"";

            let response2 = await ws.getCollaborators(this.periodSelect, this.kamSelect, this.supportSelect); 
            if(response2.type == "success"){
              this.collaboratorsOptions = await this.$parseSelectOptions(response2.data, "id", "name",[{"label": "Todos los Colaboradores","value":""}]);
              if(response2.data.length > 0){
                this.collaboratorSelect = this.collaboratorsOptions[0].value;
              }      
            }

            this.lastSupport = this.supportSelect;
            this.lastKam = this.kamSelect;
          }
          else if(this.role == "kam"){
            this.kamSelect = this.collaborator_id;
            this.supportSelect = "0";

            let response4 = await ws.getSupports(this.periodSelect); 
            if(response4.type == "success"){
              this.supportsOptions = await this.$parseSelectOptions(response4.data, "id", "name",[{"label": "Todos los Soportes","value":""}]);
              if(response4.data.length > 0 && this.lastSupport == "0"){
                this.supportSelect = this.supportsOptions[0].value;
              }      
            }

            this.lastSupport = this.supportSelect;
            this.lastKam = this.kamSelect;
          }

          await this.changeFilters();
        }
      }
    }
    else{
      this.kamSelect = "0";
      this.supportSelect = "0";
      await this.changeFilters();
    }

    this.loaded();
  },
  methods: {
    async changeFilters () {
      this.loading();

      let flag = false;

      if(this.lastKam != this.kamSelect){
          flag = true;

          let response4 = await ws.getSupports(this.periodSelect, this.kamSelect); 
          if(response4.type == "success"){
            this.supportsOptions = await this.$parseSelectOptions(response4.data, "id", "name",[{"label": "Todos los Soportes","value":""}]);
            if(response4.data.length > 0 && this.supportSelect == "0"){
              this.supportSelect = this.supportsOptions[0].value;
            }      
          }

          this.lastKam = this.kamSelect;
      }

      if(this.lastPeriod != this.periodSelect){
        flag = true;

        this.lastPeriod = this.periodSelect;
      }

      if(this.lastSupport != this.supportSelect){
        flag = true;

        this.lastSupport = this.supportSelect;
      }

      if(flag){
        let response2 = await ws.getCollaborators(this.periodSelect, this.kamSelect, this.supportSelect); 
        if(response2.type == "success"){
          this.collaboratorsOptions = await this.$parseSelectOptions(response2.data, "id", "name",[{"label": "Todos los Colaboradores","value":""}]);
          if(response2.data.length > 0){
            this.collaboratorSelect = this.collaboratorsOptions[0].value;
          }      
        }
      }

      let filters = {
        collaborator_id : this.collaboratorSelect > 0 ? this.collaboratorSelect : "0",
        customer_id : this.customerSelect > 0 ? this.customerSelect : "0",
        support_id : this.supportSelect > 0 ? this.supportSelect : "0",
        kam_id : this.kamSelect > 0 ? this.kamSelect : "0",
        period : this.periodSelect,
      };

      let response = await ws.getCollaboratorsReport(filters);

      if(response.type == "success"){
        this.collaborators = response.data.collaborators;      
        this.fields = response.data.fields;   
      }

      this.loaded();
    },
    showToast(type, message){
        store.commit('toast', {color: type, message: message});
    },
    color(percentage){
      let color = "darkred";

      if(percentage >= 90){
        color = "darkgreen";
      }
      else if(percentage >= 70){
        color = "green";
      }
      else if(percentage >= 50){
        color = "yellow";
      }
      else if(percentage >= 30){
        color = "red";
      }
      else if(percentage >= 0){
        color = "darkred";
      }

      return color;
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>

<style>
  .warning{
  background-color: #F9B115;
  }
  .success{
    background-color: #1B9E3E;
  }
  .danger{
    background-color: #E55353
  }
  .other{
    background-color: #6b7785
  }
  .card.success{
    color:black !important;
    font-weight: bold !important;
  }
  .card-header-actions select{
    font-size: 12px;
  }
  .card-header{
    font-size: 20px;
    padding: 10px 15px 10px 20px;

  }

  .darkgreen{
    background-color: #2ecc71;
  }
  .green{
    background-color: #a9dfbf;
  }
  .yellow{
    background-color: #f9e79f;
  }
  .red{
    background-color: #f5b7b1;
  }
  .darkred{
    background-color: #e74c3c;
  }
  .default{
    background-color: #ffffff;
  }
</style>